import { useEffect, useState } from "react";
import { NotificationItemProps } from "./notificationItem.interface";
import moment from "moment-jalaali";
import { advancedResponseValidator, del, get, put, responseValidator } from "../../../../../scripts/api";
import API from "../../../../../urls/api";
import { IsReadTypeEnum, NotificationTypes, ResourceType } from "../../../../../interfaces/general";
import { useNavigate } from "react-router-dom";
import PATH from "../../../../../urls/path";
import { handleSetDefaultSelectedItem } from "../../../../../utils/component/fileManagers/fileManager.actions";
import { ReactComponent as PlusIcon } from "../../../../../assets/images/icons/add_24px.svg";
import { ReactComponent as ClockIcn } from "../../../../../assets/images/icons/Clock.svg";
import { ReactComponent as MinusIcn } from "../../../../../assets/images/icons/Actions Minus.svg";
import Button from "../../../../../utils/component/button/button.index";
import { ButtonType } from "../../../../../utils/component/button/button.interface";
import Loader from "../../../../../utils/component/loader/loader.index";
import { getFileNameWithoutFormat, isFolder } from "../../../../../scripts/helpers";
import folderIcon from "../../../../../assets/images/fileManager/Folder.svg";
import { setResourceIcon } from "../../../../../scripts/resourceHelper";

export default function NotificationItem(props: NotificationItemProps): JSX.Element {
    let navigate = useNavigate();
    let timer: any = undefined;
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [resource, setResource] = useState<ResourceType | undefined | null>(undefined);
    const [parentHash, setParentHash] = useState<string>("");

    useEffect(() => {
        return () => {
            clearTimeout(timer);
        };
    }, []);

    const handleRemoveNotification = () => {
        return new Promise((resolve, reject) => {
            del(
                (data, status) => {
                    if (responseValidator(status)) {
                        props.onDelete(props.notification.id);
                        resolve(true);
                    }
                },
                API.notification.remove(),
                { ids: [props.notification.id] }
            );
        });
    };

    const handleUnreadNotification = () => {
        return new Promise((resolve, reject) => {
            put(
                (data, status) => {
                    if (responseValidator(status)) {
                        props.onUpdate(props.notification.id, IsReadTypeEnum.UNREAD);
                        resolve(true);
                    }
                },
                API.notification.unread(),
                { ids: [props.notification.id] }
            );
        });
    };

    const handleReadNotification = () => {
        return new Promise((resolve, reject) => {
            put(
                (data, status) => {
                    props.onUpdate(props.notification.id, IsReadTypeEnum.READ);
                    resolve(true);
                },
                API.notification.read(),
                { ids: [props.notification.id] }
            );
        });
    };

    const notificationClickHandler = () => {
        if (props.notification.is_read === IsReadTypeEnum.UNREAD) handleReadNotification();

        const objectData = {
            id: "",
            parentId: ""
        };

        if (props.notification.type === NotificationTypes.SHARED_FILE) {
            objectData.id = props.notification.data.find((el) => el.key === "object_hash")!.value;
            get(
                (data, status) => {
                    if (advancedResponseValidator(data, status)) {
                        setResource(data.obj);
                    } else {
                        setResource(null);
                    }
                },
                API.share.getObject("v4", objectData.id)
            );
        } else if (props.notification.type === NotificationTypes.LINK_UPLOUD) {
            props.notification.data.map((el) => {
                if (el.key === "object_id") objectData.id = el.value;
                else if (el.key === "parent_object_id") objectData.parentId = el.value;
            });

            get((data, status) => {
                if (advancedResponseValidator(data, status)) {
                    setResource(data);
                } else {
                    setResource(null);
                }
            }, API.fileManager.getObject(+objectData.id));
        } else if (props.notification.type === NotificationTypes.LINK_UPLOUD_IN_SHARED_FOLDER) {
            props.notification.data.map((el) => {
                if (el.key === "object_hash") objectData.id = el.value;
                else if (el.key === "parent_object_hash") objectData.parentId = el.value;
            });

            setParentHash(objectData.parentId);
            get(
                (data, status) => {
                    if (advancedResponseValidator(data, status)) {
                        setResource(data.obj);
                    } else {
                        setResource(null);
                    }
                },
                API.share.getObject("v4", objectData.id)
            );
        }
    };

    const navigateHandler = (type: NotificationTypes) => {
        if (type === NotificationTypes.SHARED_FILE) {
            navigate(`${PATH.shared}`, { state: { paramItem: resource!.id } });
            timer = setTimeout(() => {
                handleSetDefaultSelectedItem([resource!.id.toString()]);
            }, 300);
        } else if (type === NotificationTypes.LINK_UPLOUD) {
            navigate(resource!.parent ? `${PATH.files}?path=${resource!.parent}` : `${PATH.files}`);
            timer = setTimeout(() => {
                handleSetDefaultSelectedItem([resource!.id.toString()]);
            }, 300);
        } else if (type === NotificationTypes.LINK_UPLOUD_IN_SHARED_FOLDER) {
            navigate(`${PATH.shared}?path=${parentHash}`);
            timer = setTimeout(() => {
                handleSetDefaultSelectedItem([resource!.id.toString()]);
            }, 300);
        }
    };

    return (
        <div
            className={`flex flex-col gap-4 p-2 ${props.notification.is_read === IsReadTypeEnum.UNREAD ? "bg-primary-100" : "bg-white"} border-b-2 border-secondary-300 `}
            onClick={() => {
                setIsOpen(!isOpen);
                !isOpen && notificationClickHandler();
            }}
        >
            <div className="grid grid-cols-12">
                <div className="col-span-1 mt-1">
                    {!!(props.notification.is_read === IsReadTypeEnum.UNREAD) && <div className="w-2 h-2 bg-primary-600 rounded-full"></div>}
                </div>
                <div className={`col-span-9 text-xs text-secondary-800 font-normal text-justify ${isOpen ? "" : "truncate"}`}>
                    {props.notification.message}
                </div>
                <div className="col-span-2 justify-self-center">
                    {isOpen ? <MinusIcn className="pointer-events-none" /> : <PlusIcon className="pointer-events-none" />}
                </div>
            </div>
            <div className="flex items-center justify-between px-4">
                <div className="flex items-center justify-between gap-1 mr-2">
                    <ClockIcn className="w-4 h-4 fill-secondary-600" />
                    <span className="text-secondary-600 text-[8px] font-normal">{moment.unix(props.notification.created_at).fromNow()}</span>
                </div>
                {props.notification.type === NotificationTypes.USER_LOGIN && (
                    <span className="text-secondary-600 text-[8px] font-normal">ورود به حساب کاربری</span>
                )}
                {props.notification.type === NotificationTypes.PLAN && (
                    <span className="text-secondary-600 text-[8px] font-normal">فضای ذخیره‌سازی ابری</span>
                )}
                {props.notification.type === NotificationTypes.SHARED_FILE && (
                    <span className="text-secondary-600 text-[8px] font-normal">اشتراک فایل</span>
                )}
                {props.notification.type === NotificationTypes.LINK_UPLOUD ||
                    (props.notification.type === NotificationTypes.LINK_UPLOUD_IN_SHARED_FOLDER && (
                        <span className="text-secondary-600 text-[8px] font-normal">آپلود از طریق لینک</span>
                    ))}
            </div>
            {isOpen && (
                <>
                    {[NotificationTypes.SHARED_FILE, NotificationTypes.LINK_UPLOUD, NotificationTypes.LINK_UPLOUD_IN_SHARED_FOLDER].includes(
                        props.notification.type
                    ) && (
                        <>
                            {resource === undefined && <Loader />}
                            {resource !== undefined && resource !== null && (
                                <div
                                    className="flex items-center gap-2 bg-secondary-200 py-[6px] px-3 rounded-lg mx-4"
                                    onClick={() => navigateHandler(props.notification.type)}
                                >
                                    <img
                                        className={`w-[14px] h-[14px] aspect-square drop-shadow-lg shrink-0`}
                                        src={isFolder(resource) ? folderIcon : setResourceIcon(getFileNameWithoutFormat(resource).format)}
                                        alt={resource.name}
                                        loading="lazy"
                                    />
                                    <span className="text-xs font-normal text-black">{resource.name}</span>
                                </div>
                            )}
                        </>
                    )}
                    <div className="flex gap-2 px-4">
                        {props.notification.is_read === IsReadTypeEnum.UNREAD ? (
                            <Button
                                text="تبدیل به خوانده شده"
                                autoFocus={false}
                                className="!h-10 text-sm bg-white"
                                type={ButtonType.SECONDARY}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleReadNotification();
                                }}
                            />
                        ) : (
                            <Button
                                text="تبدیل به خوانده نشده"
                                autoFocus={false}
                                className="!h-10 text-sm bg-white"
                                type={ButtonType.SECONDARY}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleUnreadNotification();
                                }}
                            />
                        )}
                        <Button
                            text="حذف"
                            autoFocus={false}
                            className="!h-10 text-sm !bg-red-600 !text-white hover:!bg-red-700"
                            type={ButtonType.DELETE}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleRemoveNotification();
                            }}
                        />
                    </div>
                </>
            )}
        </div>
    );
}
